var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChange,
    intersection: {
      rootMargin: '20%'
    }
  }),expression:"{\n    callback: visibilityChange,\n    intersection: {\n      rootMargin: '20%'\n    }\n  }"}],tag:"div",staticClass:"parallax",class:_vm.classes},[_c('fade',{attrs:{"appear":""},on:{"before-leave":_vm.beforeLeave,"after-leave":_vm.afterLeave}},[(_vm.always || _vm.visible)?_c('div',{staticClass:"parallax__content",style:(_vm.style)},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }